import { CompleteResponse } from "./CompleteResponse";
import { PaymentProviderType } from "../enums/PaymentProviderType";

export type BaseCompleteResponseModelType = {
  response: CompleteResponse;
  redirectHtml: string | null;
  paymentId: string | null;
  paymentProviderType: PaymentProviderType | null;
  message: string;
};

export type CompleteOrderResponseModelType = BaseCompleteResponseModelType & {
  orderId: number | null;
  guid: string | null;
  parentOrderId: number | null;
  parentOrderGuid: string | null;
};

export type CompleteBookingResponseModelType = BaseCompleteResponseModelType & {
  start: string | null;
  restaurantId: string | null;
};

export class BaseCompleteResponseModel {
  response: CompleteResponse;
  redirectHtml: string | null;
  paymentId: string | null;
  paymentProviderType: PaymentProviderType | null;
  message: string;

  constructor(json: BaseCompleteResponseModelType) {
    this.response = json.response;
    this.redirectHtml = json.redirectHtml;
    this.paymentId = json.paymentId;
    this.paymentProviderType = json.paymentProviderType;
    this.message = json.message;
  }

  isPaymentRedirect(): boolean {
    return (
      (this.redirectHtml !== null && this.redirectHtml.length > 0) ||
      (this.paymentId !== null && this.paymentId.length > 0)
    );
  }

  isSuccess(): boolean {
    return this.response === CompleteResponse.Success;
  }

  isError(): boolean {
    return this.response === CompleteResponse.Error;
  }

  isVerificationRequired(): boolean {
    return this.response === CompleteResponse.VerificationRequired;
  }
}

export class CompleteOrderResponseModel extends BaseCompleteResponseModel {
  orderId: number | null;
  guid: string | null;
  parentOrderId: number | null;
  parentOrderGuid: string | null;

  constructor(json: CompleteOrderResponseModelType) {
    super(json);
    this.orderId = json.orderId;
    this.guid = json.guid;
    this.parentOrderId = json.parentOrderId;
    this.parentOrderGuid = json.parentOrderGuid;
  }

  isPaymentRedirect(): boolean {
    return super.isPaymentRedirect() && this.guid !== null;
  }
}

export class CompleteBookingResponseModel extends BaseCompleteResponseModel {
  start: string | null;
  restaurantId: string | null;

  constructor(json: CompleteBookingResponseModelType) {
    super(json);
    this.start = json.start;
    this.restaurantId = json.restaurantId;
  }
}
